export { default } from './LeilaoDeVeiculos';
